import { toast } from "react-toastify";
import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface CreditSystemStatisticsState {
  CreditSystemStatistics: {
    load: boolean;
    data: [];
  };
}

export const CreditSystemStatisticsSlice = createSlice({
  name: "CreditSystemStatistics",
  initialState: {
    CreditSystemStatistics: {
      load: false,
      data: [],
    },
  } as CreditSystemStatisticsState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchCreditSystemStatistics.pending, (state: CreditSystemStatisticsState) => {
        state.CreditSystemStatistics.load = true;
      })
      .addCase(fetchCreditSystemStatistics.fulfilled, (state: CreditSystemStatisticsState, action: any) => {
        state.CreditSystemStatistics.data = action.payload;
        state.CreditSystemStatistics.load = false;
      })
      .addCase(fetchCreditSystemStatistics.rejected, (state: CreditSystemStatisticsState) => {
        state.CreditSystemStatistics.load = false;
      })
  },
});

export default CreditSystemStatisticsSlice.reducer;

export const fetchCreditSystemStatistics = createAsyncThunk(
  "CreditSystemStatistics/fetchCreditSystemStatistics",
  async (param: { apiParam: { tpi_firm_id: any } }) => {
    try {
      const { data } = await DataServer.get("api/GetCreditSystemStatistics?company_id=" + param.apiParam.tpi_firm_id);
      return data.data;
    } catch (error) {
    }
  }
);


export const AddCredit = createAsyncThunk(
    "assigncoupon/AddCredit",
    async (param: { apiParam: { company_id: any, purchased_credit: any, credit_type: any }, navigation: any }, thunkAPI) => {
        try {
            const { data } = await DataServer.post("api/addpurchasedcredit", {
                company_id: param.apiParam.company_id,
                purchased_credit: param.apiParam.purchased_credit,
                credit_type: param.apiParam.credit_type,
            });

            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                // param.navigation("/coupon-summary");
            };
            return data.data;
        } catch (error) {
        }
    }
);
